var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-top"},[(_vm.btnFlag)?_c('van-icon',{ref:"box",staticClass:"back-btn",attrs:{"name":"back-top"},on:{"click":_vm.backTop}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }